import { Trans } from 'react-i18next';

import { Translate, useTranslate } from '@dreryk/react-common';
import { TextView } from '@dreryk/react-components';

import { invoiceCreateModalTranslationKeys } from '../../../translations';
import { InvoicePaymentMethod } from '../../../types';

type PaymentMethodTextViewProps = {
   readonly paymentMethod: InvoicePaymentMethod;
};

export const PaymentMethodTextView = (props: PaymentMethodTextViewProps): JSX.Element => {
   const { paymentMethod } = props;
   const translate = useTranslate();

   return (
      <TextView testId={'paymentMethod'} label={invoiceCreateModalTranslationKeys.paymentMethod}>
         {paymentMethod.type === 'OTHER' && paymentMethod.description ? (
            <Trans
               i18nKey={invoiceCreateModalTranslationKeys.paymentMethodDescription}
               values={{
                  method: translate(invoiceCreateModalTranslationKeys.paymentMethodMap[paymentMethod.type]),
                  description: paymentMethod.description,
               }}
            />
         ) : (
            <Translate>{invoiceCreateModalTranslationKeys.paymentMethodMap[paymentMethod.type]}</Translate>
         )}
      </TextView>
   );
};
